import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  Autocomplete,
  Paper,
  Box,
  Stack,
  Divider,
  Button,
  InputAdornment,
  Backdrop,
  CircularProgress,
  Alert,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import Layout from "../../layout/Layout";
import * as Yup from "yup";
import {
  insertSalesCallAPI,
  updateSalesCallByIdAPI,
  fetchSalesCallByIdAPI,
  fetchCustomerDDAPI,
} from "../../config";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import BusinessIcon from "@mui/icons-material/Business";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useParams } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useFormik } from "formik";
import { AlertMessage } from "../../components/AlertMessage";
import { apiData } from "../../services/api_service";
import { emirates, isKnownEmirate } from "../../components/constants";

import PersonIcon from "@mui/icons-material/Person";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CategoryIcon from "@mui/icons-material/Category";
import SchoolIcon from "@mui/icons-material/School";
import { MenuItem } from "@mui/material";

const customerTypeOptions = [
  { value: "Individual", label: "Individual" },
  { value: "Coach", label: "Coach" },
  { value: "Academy Owner", label: "Academy Owner" },
  { value: "School PT Teacher", label: "School PT Teacher" },
  { value: "Admin / Manager", label: "Admin / Manager" },
];

const countryCodes = [
  // Middle East & GCC
  { code: "+971", label: "+971 (UAE)" },
  { code: "+966", label: "+966 (Saudi Arabia)" },
  { code: "+968", label: "+968 (Oman)" },
  { code: "+973", label: "+973 (Bahrain)" },
  { code: "+965", label: "+965 (Kuwait)" },
  { code: "+974", label: "+974 (Qatar)" },
  { code: "+20", label: "+20 (Egypt)" },
  { code: "+962", label: "+962 (Jordan)" },
  { code: "+961", label: "+961 (Lebanon)" },
  { code: "+964", label: "+964 (Iraq)" },
  { code: "+98", label: "+98 (Iran)" },
  { code: "+963", label: "+963 (Syria)" },
  { code: "+967", label: "+967 (Yemen)" },
  { code: "+970", label: "+970 (Palestine)" },
  { code: "+90", label: "+90 (Turkey)" },
  { code: "+357", label: "+357 (Cyprus)" },

  // South Asia
  { code: "+91", label: "+91 (India)" },
  { code: "+92", label: "+92 (Pakistan)" },
  { code: "+880", label: "+880 (Bangladesh)" },
  { code: "+94", label: "+94 (Sri Lanka)" },
  { code: "+977", label: "+977 (Nepal)" },
  { code: "+93", label: "+93 (Afghanistan)" },
  { code: "+960", label: "+960 (Maldives)" },
  { code: "+975", label: "+975 (Bhutan)" },

  // East & Southeast Asia
  { code: "+86", label: "+86 (China)" },
  { code: "+852", label: "+852 (Hong Kong)" },
  { code: "+853", label: "+853 (Macao)" },
  { code: "+886", label: "+886 (Taiwan)" },
  { code: "+81", label: "+81 (Japan)" },
  { code: "+82", label: "+82 (South Korea)" },
  { code: "+65", label: "+65 (Singapore)" },
  { code: "+60", label: "+60 (Malaysia)" },
  { code: "+66", label: "+66 (Thailand)" },
  { code: "+62", label: "+62 (Indonesia)" },
  { code: "+63", label: "+63 (Philippines)" },
  { code: "+84", label: "+84 (Vietnam)" },
  { code: "+95", label: "+95 (Myanmar)" },
  { code: "+855", label: "+855 (Cambodia)" },
  { code: "+856", label: "+856 (Laos)" },
  { code: "+673", label: "+673 (Brunei)" },
  { code: "+976", label: "+976 (Mongolia)" },

  // Central Asia & Caucasus
  { code: "+7", label: "+7 (Kazakhstan / Russia)" },
  { code: "+998", label: "+998 (Uzbekistan)" },
  { code: "+993", label: "+993 (Turkmenistan)" },
  { code: "+996", label: "+996 (Kyrgyzstan)" },
  { code: "+992", label: "+992 (Tajikistan)" },
  { code: "+994", label: "+994 (Azerbaijan)" },
  { code: "+374", label: "+374 (Armenia)" },
  { code: "+995", label: "+995 (Georgia)" },

  // Americas & Caribbean
  { code: "+1", label: "+1 (USA / Canada)" },
  { code: "+52", label: "+52 (Mexico)" },
  { code: "+55", label: "+55 (Brazil)" },
  { code: "+54", label: "+54 (Argentina)" },
  { code: "+57", label: "+57 (Colombia)" },
  { code: "+56", label: "+56 (Chile)" },
  { code: "+51", label: "+51 (Peru)" },
  { code: "+58", label: "+58 (Venezuela)" },
  { code: "+593", label: "+593 (Ecuador)" },
  { code: "+591", label: "+591 (Bolivia)" },
  { code: "+595", label: "+595 (Paraguay)" },
  { code: "+598", label: "+598 (Uruguay)" },
  { code: "+506", label: "+506 (Costa Rica)" },
  { code: "+507", label: "+507 (Panama)" },
  { code: "+502", label: "+502 (Guatemala)" },
  { code: "+504", label: "+504 (Honduras)" },
  { code: "+503", label: "+503 (El Salvador)" },
  { code: "+505", label: "+505 (Nicaragua)" },
  { code: "+53", label: "+53 (Cuba)" },
  { code: "+1809", label: "+1-809 (Dominican Republic)" },
  { code: "+1787", label: "+1-787 (Puerto Rico)" },
  { code: "+1876", label: "+1-876 (Jamaica)" },
  { code: "+1868", label: "+1-868 (Trinidad & Tobago)" },

  // Europe
  { code: "+44", label: "+44 (UK)" },
  { code: "+49", label: "+49 (Germany)" },
  { code: "+33", label: "+33 (France)" },
  { code: "+39", label: "+39 (Italy)" },
  { code: "+34", label: "+34 (Spain)" },
  { code: "+351", label: "+351 (Portugal)" },
  { code: "+31", label: "+31 (Netherlands)" },
  { code: "+32", label: "+32 (Belgium)" },
  { code: "+41", label: "+41 (Switzerland)" },
  { code: "+43", label: "+43 (Austria)" },
  { code: "+353", label: "+353 (Ireland)" },
  { code: "+45", label: "+45 (Denmark)" },
  { code: "+47", label: "+47 (Norway)" },
  { code: "+46", label: "+46 (Sweden)" },
  { code: "+358", label: "+358 (Finland)" },
  { code: "+354", label: "+354 (Iceland)" },
  { code: "+48", label: "+48 (Poland)" },
  { code: "+420", label: "+420 (Czech Republic)" },
  { code: "+421", label: "+421 (Slovakia)" },
  { code: "+36", label: "+36 (Hungary)" },
  { code: "+40", label: "+40 (Romania)" },
  { code: "+359", label: "+359 (Bulgaria)" },
  { code: "+30", label: "+30 (Greece)" },
  { code: "+385", label: "+385 (Croatia)" },
  { code: "+381", label: "+381 (Serbia)" },
  { code: "+386", label: "+386 (Slovenia)" },
  { code: "+387", label: "+387 (Bosnia & Herzegovina)" },
  { code: "+355", label: "+355 (Albania)" },
  { code: "+380", label: "+380 (Ukraine)" },
  { code: "+375", label: "+375 (Belarus)" },
  { code: "+370", label: "+370 (Lithuania)" },
  { code: "+371", label: "+371 (Latvia)" },
  { code: "+372", label: "+372 (Estonia)" },
  { code: "+356", label: "+356 (Malta)" },

  // Africa
  { code: "+27", label: "+27 (South Africa)" },
  { code: "+234", label: "+234 (Nigeria)" },
  { code: "+254", label: "+254 (Kenya)" },
  { code: "+233", label: "+233 (Ghana)" },
  { code: "+212", label: "+212 (Morocco)" },
  { code: "+213", label: "+213 (Algeria)" },
  { code: "+216", label: "+216 (Tunisia)" },
  { code: "+218", label: "+218 (Libya)" },
  { code: "+249", label: "+249 (Sudan)" },
  { code: "+251", label: "+251 (Ethiopia)" },
  { code: "+255", label: "+255 (Tanzania)" },
  { code: "+256", label: "+256 (Uganda)" },
  { code: "+250", label: "+250 (Rwanda)" },
  { code: "+221", label: "+221 (Senegal)" },
  { code: "+225", label: "+225 (Ivory Coast)" },
  { code: "+237", label: "+237 (Cameroon)" },
  { code: "+244", label: "+244 (Angola)" },
  { code: "+258", label: "+258 (Mozambique)" },
  { code: "+263", label: "+263 (Zimbabwe)" },
  { code: "+260", label: "+260 (Zambia)" },
  { code: "+230", label: "+230 (Mauritius)" },

  // Oceania & Pacific
  { code: "+61", label: "+61 (Australia)" },
  { code: "+64", label: "+64 (New Zealand)" },
  { code: "+675", label: "+675 (Papua New Guinea)" },
  { code: "+679", label: "+679 (Fiji)" },
];

const validateUaePhone = (value) => {
  if (!value) return true;
  const clean = value.replace(/[\s-]/g, "");
  const genericPhoneRegex = /^\+?\d{6,15}$/;
  if (!genericPhoneRegex.test(clean)) {
    return "Enter a valid phone number";
  }
  return true;
};

const validationSchema = Yup.object().shape({
  call_date: Yup.string().required("Call Date is required"),
  followup_date: Yup.string().nullable(),
  company_name: Yup.string()
    .required("Company Name is required")
    .min(2, "Minimum 2 characters")
    .max(150, "Maximum 150 characters"),
  customer_entity_name: Yup.string().nullable(),
  customer_type: Yup.string().nullable(),
  location: Yup.string().nullable(),
  contact_phone: Yup.string()
    .required("Contact Phone is required")
    .test("valid-phone", (value, ctx) => {
      const result = validateUaePhone(value);
      return result === true ? true : ctx.createError({ message: result });
    }),
  contact_email: Yup.string()
    .required("Email is required")
    .test("valid-email", "Enter a valid email address", (value) => {
      if (!value) return true;
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }),
  remarks: Yup.string()
    .required("Remarks are required")
    .test("min-lines", "Remarks must be at least 3 lines long", (value) => {
      if (!value) return false;
      const lines = value.split("\n").filter((line) => line.trim().length > 0);
      return lines.length >= 3 || value.trim().length >= 30;
    }),
  expected_business: Yup.string().nullable(),
});

const SalesCallAdd = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const salesExecName = user?.employee_name || user?.name || user?.username || "Sales Executive";
  const navigate = useNavigate();
  const alertRef = useRef();
  const { id } = useParams();
  const isEdit = Boolean(id);
  const [loading, setLoading] = useState(false);
  // Set when the server says this report can't be edited any more (created
  // on an earlier day and the user isn't Admin).
  const [editLocked, setEditLocked] = useState(false);
  const [customerList, setCustomerList] = useState([]);

  const formik = useFormik({
    initialValues: {
      call_date: dayjs().format("YYYY-MM-DD"),
      followup_date: "",
      customer_id: null,
      company_name: "",
      customer_entity_name: "",
      customer_type: "",
      locationOption: "",
      location: "",
      countryCode: "+971",
      contact_phone: "",
      contact_email: "",
      remarks: "",
      expected_business: "",
      sales_exec_name: salesExecName,
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const fullPhone = values.contact_phone
          ? values.contact_phone.trim().startsWith("+")
            ? values.contact_phone.trim()
            : `${values.countryCode || "+971"} ${values.contact_phone.trim()}`
          : "";

        const payload = {
          ...values,
          contact_phone: fullPhone,
          country_code: values.countryCode || "+971",
          user_id: user.emp_id,
        };

        let result;
        if (id) {
          result = await apiData(
            "put",
            `${updateSalesCallByIdAPI}/${id}`,
            payload
          );
        } else {
          result = await apiData("post", insertSalesCallAPI, payload);
        }

        if (result.success) {
          alertRef.current.triggerAlert(
            JSON.stringify({ message: result.msg, messageType: "success" })
          );
          setTimeout(() => {
            navigate("/sales-call-report/list");
          }, 1500);
        } else {
          alertRef.current.triggerAlert(
            JSON.stringify({ message: result.msg, messageType: "error" })
          );
        }
      } catch (error) {
        alertRef.current.triggerAlert(
          JSON.stringify({
            message: error?.message || "Something went wrong.",
            messageType: "error",
          })
        );
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const result = await apiData("get", fetchCustomerDDAPI);
        if (result.data?.result) {
          setCustomerList(result.data.result);
        } else if (Array.isArray(result.data)) {
          setCustomerList(result.data);
        }
      } catch (error) {
        console.error("Failed to fetch customers:", error);
      }
    };
    fetchCustomers();
  }, []);

  const extractPhoneAndCode = (phoneInput, defaultCode = "+971") => {
    let raw = String(phoneInput || "").trim();
    if (!raw) return { countryCode: defaultCode, phone: "" };

    if (raw.startsWith("00")) {
      raw = "+" + raw.slice(2);
    }

    if (raw.startsWith("+")) {
      const matched = countryCodes.find((c) => raw.startsWith(c.code));
      if (matched) {
        const phone = raw.slice(matched.code.length).trim();
        return { countryCode: matched.code, phone };
      }
    }

    const matchedNoPlus = countryCodes.find((c) => {
      const digits = c.code.replace("+", "");
      return raw.startsWith(digits) && raw.length > digits.length + 5;
    });
    if (matchedNoPlus) {
      const digits = matchedNoPlus.code.replace("+", "");
      const phone = raw.slice(digits.length).trim();
      return { countryCode: matchedNoPlus.code, phone };
    }

    return { countryCode: defaultCode, phone: raw };
  };

  useEffect(() => {
    if (id) {
      const fetchSalesCall = async () => {
        try {
          const result = await apiData("get", `${fetchSalesCallByIdAPI}/${id}`);
          if (result.success && result.data) {
            const record = Array.isArray(result.data)
              ? result.data[0]
              : result.data;
            setEditLocked(record.can_edit === false);
            const locVal = record.location || "";
            const isKnown = isKnownEmirate(locVal);

            const phoneVal = record.contact_phone || "";
            const { countryCode, phone } = extractPhoneAndCode(
              phoneVal,
              record.country_code || "+971"
            );

            formik.setValues({
              call_date: record.call_date
                ? dayjs(record.call_date).format("YYYY-MM-DD")
                : dayjs().format("YYYY-MM-DD"),
              followup_date: record.followup_date
                ? dayjs(record.followup_date).format("YYYY-MM-DD")
                : "",
              customer_id: record.customer_id || null,
              company_name: record.company_name || "",
              customer_entity_name: record.customer_entity_name || "",
              customer_type: record.customer_type || "",
              locationOption: locVal ? (isKnown ? locVal : "Others") : "",
              location: locVal,
              countryCode,
              contact_phone: phone,
              contact_email: record.contact_email || "",
              remarks: record.remarks || "",
              expected_business: record.expected_business || "",
              sales_exec_name: record.created_by_name || salesExecName,
            });
          } else {
            alertRef.current.triggerAlert(
              JSON.stringify({
                message: "Sales call record not found",
                messageType: "error",
              })
            );
          }
        } catch (error) {
          alertRef.current.triggerAlert(
            JSON.stringify({
              message: error?.message || "Something went wrong.",
              messageType: "error",
            })
          );
        }
      };
      fetchSalesCall();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Picking an existing customer pre-fills contact details; typing a name that
  // isn't in Customer Master (freeSolo) just sets it as a plain new company
  // name — companies visited don't have to already exist.
  const handleCustomerChange = (customer) => {
    formik.setFieldValue("customer_id", customer ? customer.customer_id : null);
    if (customer) {
      formik.setFieldValue("company_name", customer.company_name || customer.name || "");
      formik.setFieldValue("customer_entity_name", customer.name || "");

      const phoneVal =
        customer.phone_number ||
        customer.phone ||
        customer.contact_phone ||
        customer.mobile ||
        customer.contact_no ||
        "";
      const { countryCode, phone } = extractPhoneAndCode(phoneVal);

      formik.setFieldValue("countryCode", countryCode);
      formik.setFieldValue("contact_phone", phone);
      formik.setFieldValue(
        "contact_email",
        customer.email || customer.contact_email || ""
      );
      const custLoc = customer.emirate || customer.location || customer.address || "";
      if (custLoc) {
        const isKnown = isKnownEmirate(custLoc);
        formik.setFieldValue("locationOption", isKnown ? custLoc : "Others");
        formik.setFieldValue("location", custLoc);
      }
    }
  };

  const adorn = (icon) => ({
    startAdornment: (
      <InputAdornment position="start">{icon}</InputAdornment>
    ),
  });

  return (
    <Layout>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Box sx={{ pt: 0 }}>
        <AlertMessage ref={alertRef} />

        {/* Page header */}
        <Grid className="employee-form bold-header" sx={{ mb: 0.5 }}>
          <Grid container spacing={3}>
            <Grid
              textAlign="center"
              item
              className="form-lable"
              xs={12}
              lg={6}
              md={6}
            >
              <Typography className="page_title" textAlign="left">
                {isEdit ? "Edit Sales Call Report" : "Sales Call Report"}
              </Typography>
              <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/dashboard">
                  Dashboard
                </Link>
                <Typography color="text.primary">Sales Call Reports</Typography>
                <Typography color="text.primary">
                  {isEdit ? "Edit" : "Add"}
                </Typography>
              </Breadcrumbs>
            </Grid>
            <Grid
              textAlign="right"
              item
              className="form-lable"
              xs={12}
              lg={6}
              md={6}
            >
              <LoadingButton
                size="medium"
                variant="contained"
                color="secondary"
                className="button_first"
                onClick={() => navigate("/sales-call-report/list")}
              >
                List Sales Calls
              </LoadingButton>
              <LoadingButton
                size="medium"
                variant="contained"
                color="primary"
                onClick={() => navigate(-1)}
                startIcon={<ArrowBackIosIcon />}
              >
                Back
              </LoadingButton>
            </Grid>
          </Grid>
        </Grid>

        {isEdit && editLocked && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            This sales call report is locked. Reports can only be edited on the
            day they were created. Please contact Admin for changes.
          </Alert>
        )}

        {/* Form card */}
        <Paper
          elevation={0}
          sx={{
            width: "100%",
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 3,
            overflow: "hidden",
            boxShadow: "0 1px 3px rgba(16,24,40,0.06)",
          }}
        >
          {/* Section header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              px: 3,
              py: 2,
              bgcolor: (t) => alpha(t.palette.primary.main, 0.06),
              borderBottom: "1px solid",
              borderColor: "divider",
            }}
          >
            <Box
              sx={{
                width: 42,
                height: 42,
                borderRadius: 2,
                display: "grid",
                placeItems: "center",
                bgcolor: (t) => alpha(t.palette.primary.main, 0.14),
                color: "primary.main",
              }}
            >
              <PhoneInTalkIcon />
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 700 }}>Call Details</Typography>
              <Typography variant="body2" color="text.secondary">
                Log a company visit and the opportunity it may bring.
              </Typography>
            </Box>
          </Box>

          <Box component="form" onSubmit={formik.handleSubmit} sx={{ p: 3 }}>
            <Grid container spacing={2.5}>
              {/* Sales Executive Name (Read-only) */}
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  size="small"
                  label="Sales Executive Name"
                  name="sales_exec_name"
                  value={formik.values.sales_exec_name}
                  disabled
                  InputProps={adorn(
                    <PersonIcon fontSize="small" color="action" />
                  )}
                />
              </Grid>

              {/* Call Date */}
              <Grid item xs={12} sm={6} md={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <MobileDatePicker
                    label="Call Date"
                    value={
                      formik.values.call_date
                        ? dayjs(formik.values.call_date)
                        : null
                    }
                    inputFormat="DD-MM-YYYY"
                    onChange={(date) =>
                      formik.setFieldValue(
                        "call_date",
                        date ? date.format("YYYY-MM-DD") : ""
                      )
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size="small"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              <CalendarMonthIcon
                                fontSize="small"
                                color="action"
                              />
                            </InputAdornment>
                          ),
                        }}
                        error={
                          formik.touched.call_date &&
                          Boolean(formik.errors.call_date)
                        }
                        helperText={
                          formik.touched.call_date && formik.errors.call_date
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>

              {/* Follow-up Date */}
              <Grid item xs={12} sm={6} md={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <MobileDatePicker
                    label="Follow-up Date"
                    value={
                      formik.values.followup_date
                        ? dayjs(formik.values.followup_date)
                        : null
                    }
                    inputFormat="DD-MM-YYYY"
                    onChange={(date) =>
                      formik.setFieldValue(
                        "followup_date",
                        date ? date.format("YYYY-MM-DD") : ""
                      )
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size="small"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              <CalendarMonthIcon
                                fontSize="small"
                                color="action"
                              />
                            </InputAdornment>
                          ),
                        }}
                        error={
                          formik.touched.followup_date &&
                          Boolean(formik.errors.followup_date)
                        }
                        helperText={
                          formik.touched.followup_date && formik.errors.followup_date
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>

              {/* Company Name */}
              <Grid item xs={12} sm={6} md={3}>
                <Autocomplete
                  freeSolo
                  size="small"
                  options={customerList}
                  getOptionLabel={(option) =>
                    typeof option === "string"
                      ? option
                      : option
                      ? `${option.company_name || option.name} - ${option.phone_number || ""}`
                      : ""
                  }
                  value={
                    customerList.find(
                      (c) => c.customer_id == formik.values.customer_id
                    ) ||
                    formik.values.company_name ||
                    null
                  }
                  onChange={(event, newValue) => {
                    if (typeof newValue === "string" || !newValue) {
                      formik.setFieldValue("customer_id", null);
                      formik.setFieldValue("company_name", newValue || "");
                    } else {
                      handleCustomerChange(newValue);
                    }
                  }}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      formik.setFieldValue("customer_id", null);
                      formik.setFieldValue("company_name", newInputValue);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Company Name"
                      placeholder="Choose customer or type company"
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            <InputAdornment position="start">
                              <BusinessIcon fontSize="small" color="action" />
                            </InputAdornment>
                            {params.InputProps.startAdornment}
                          </>
                        ),
                      }}
                      error={
                        formik.touched.company_name &&
                        Boolean(formik.errors.company_name)
                      }
                      helperText={
                        formik.touched.company_name &&
                        formik.errors.company_name
                      }
                      onBlur={formik.handleBlur}
                    />
                  )}
                />
              </Grid>

              {/* Customer Name / Store Name / School / Academy */}
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  name="customer_entity_name"
                  label="Customer / Store / School / Academy Name"
                  placeholder="Individual, store, school, or academy name"
                  fullWidth
                  size="small"
                  value={formik.values.customer_entity_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputProps={adorn(
                    <SchoolIcon fontSize="small" color="action" />
                  )}
                />
              </Grid>

              {/* Customer Type Dropdown */}
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Customer Type"
                  name="customer_type"
                  value={formik.values.customer_type || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputProps={adorn(
                    <CategoryIcon fontSize="small" color="action" />
                  )}
                >
                  <MenuItem value="">
                    <em>Select Customer Type</em>
                  </MenuItem>
                  {customerTypeOptions.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* Contact Phone with Country Code Dropdown */}
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{ display: "flex", gap: 0.75 }}>
                  <Autocomplete
                    options={countryCodes}
                    getOptionLabel={(option) =>
                      typeof option === "string"
                        ? option
                        : option?.label || option?.code || ""
                    }
                    isOptionEqualToValue={(option, val) =>
                      option.code === (typeof val === "string" ? val : val?.code)
                    }
                    value={
                      countryCodes.find(
                        (c) => c.code === (formik.values.countryCode || "+971")
                      ) || {
                        code: formik.values.countryCode || "+971",
                        label: `${formik.values.countryCode || "+971"}`,
                      }
                    }
                    onChange={(event, newValue) => {
                      const selectedCode =
                        typeof newValue === "string"
                          ? newValue
                          : newValue?.code || "+971";
                      formik.setFieldValue("countryCode", selectedCode);
                    }}
                    disableClearable
                    sx={{ width: 105, flexShrink: 0 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Code"
                        size="small"
                        variant="outlined"
                      />
                    )}
                  />
                  <TextField
                    name="contact_phone"
                    label="Contact Phone"
                    fullWidth
                    size="small"
                    value={formik.values.contact_phone}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.contact_phone &&
                      Boolean(formik.errors.contact_phone)
                    }
                    helperText={
                      formik.touched.contact_phone && formik.errors.contact_phone
                    }
                  />
                </Box>
              </Grid>

              {/* Contact Email */}
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  name="contact_email"
                  label="Email"
                  fullWidth
                  size="small"
                  value={formik.values.contact_email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.contact_email &&
                    Boolean(formik.errors.contact_email)
                  }
                  helperText={
                    formik.touched.contact_email && formik.errors.contact_email
                  }
                  InputProps={adorn(
                    <EmailIcon fontSize="small" color="action" />
                  )}
                />
              </Grid>

              {/* Location / Emirates Dropdown */}
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Emirates Location"
                  name="locationOption"
                  value={formik.values.locationOption || ""}
                  onChange={(e) => {
                    const val = e.target.value;
                    formik.setFieldValue("locationOption", val);
                    if (val !== "Others") {
                      formik.setFieldValue("location", val);
                    } else if (!isKnownEmirate(formik.values.location)) {
                      // Preserve custom location value if already entered
                    } else {
                      formik.setFieldValue("location", "");
                    }
                  }}
                  onBlur={formik.handleBlur}
                  InputProps={adorn(
                    <LocationOnIcon fontSize="small" color="action" />
                  )}
                >
                  <MenuItem value="">
                    <em>Select Emirate</em>
                  </MenuItem>
                  {emirates.map((emirate) => (
                    <MenuItem key={emirate.id} value={emirate.name}>
                      {emirate.name}
                    </MenuItem>
                  ))}
                  <MenuItem value="Others">Others</MenuItem>
                </TextField>
              </Grid>

              {formik.values.locationOption === "Others" && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    name="location"
                    label="Please Specify Location"
                    placeholder="Enter city, address or region"
                    fullWidth
                    size="small"
                    value={formik.values.location}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    InputProps={adorn(
                      <LocationOnIcon fontSize="small" color="action" />
                    )}
                  />
                </Grid>
              )}

              {/* Remarks - Minimum 3 lines */}
              <Grid item xs={12}>
                <TextField
                  name="remarks"
                  label="Remarks (Minimum 3 lines)"
                  placeholder="Notes from the visit — discussion points, requirements, follow-ups (min 3 lines)..."
                  fullWidth
                  multiline
                  rows={4}
                  value={formik.values.remarks}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.remarks && Boolean(formik.errors.remarks)
                  }
                  helperText={
                    (formik.touched.remarks && formik.errors.remarks) ||
                    "Enter visit notes (at least 3 lines required)."
                  }
                />
              </Grid>

              {/* Expected Business */}
              <Grid item xs={12}>
                <TextField
                  name="expected_business"
                  label="Expected Business / Opportunity Details"
                  placeholder="Describe potential business opportunity expected from this call"
                  fullWidth
                  multiline
                  rows={3}
                  value={formik.values.expected_business}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 1.25,
              }}
            >
              <Button
                variant="outlined"
                color="inherit"
                onClick={() => navigate(-1)}
                sx={{ textTransform: "none", borderRadius: 2 }}
              >
                Cancel
              </Button>
              <LoadingButton
                type="submit"
                variant="contained"
                color="primary"
                loading={loading}
                disabled={isEdit && editLocked}
                startIcon={<SaveOutlinedIcon />}
                sx={{ textTransform: "none", borderRadius: 2, px: 3 }}
              >
                {isEdit ? "Update Sales Call" : "Save Sales Call"}
              </LoadingButton>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Layout>
  );
};

export default SalesCallAdd;
